window.addEventListener('load', event => {

    let headerPanels = document.querySelectorAll('.header-panel-video-home-v2');

    for (const headerPanel of headerPanels) {
        const fadeOutLogoOverlay = headerPanel.querySelector('[data-fade-out-logo-overlay]');
        const navLogos = document.querySelectorAll('a[data-nav-logo ]');

        if (navLogos.length && fadeOutLogoOverlay ) {
            const fadeOutLogo = fadeOutLogoOverlay.querySelector('[data-fade-out-logo]');


            if (fadeOutLogo) {
                setTimeout(function () {
                    // Hand the hero lockup off to whichever header nav logo is currently visible
                    // (desktop or mobile header), landing it exactly over that nav lockup.
                    const targetAnchor = [...navLogos].find(function (a) {
                        const nav = a.closest('nav');
                        return nav
                            && (nav.id === 'desktopNavigation' || nav.id === 'mobileHeaderNavigation')
                            && getComputedStyle(nav).display !== 'none';
                    });
                    const targetContent = targetAnchor && targetAnchor.querySelector('span:not(.sr-only)');
                    const heroContent = fadeOutLogo.querySelector('span');

                    if (targetContent && heroContent) {
                        const cur = fadeOutLogo.getBoundingClientRect();
                        const heroBox = heroContent.getBoundingClientRect();
                        const target = targetContent.getBoundingClientRect();
                        const scale = target.width / heroBox.width;
                        // Undo the -translate-x-1/2 / -translate-y-1/2 centring to get the container's layout origin.
                        const baseLeft = cur.left + cur.width / 2;
                        const baseTop = cur.top + cur.height / 2;
                        // Offset of the lockup content within its padded (p-6) container.
                        const ox = heroBox.left - cur.left;
                        const oy = heroBox.top - cur.top;
                        const tx = target.left - baseLeft - ox * scale;
                        const ty = target.top - baseTop - oy * scale;
                        fadeOutLogo.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
                        fadeOutLogo.style.opacity = '0';
                    } else {
                        // Fallback to the previous fixed landing if the nav logo can't be located.
                        fadeOutLogo.classList.add('opacity-0','!top-[5rem]','!left-[10rem]','lg:!left-[11rem]','scale-[0.5]');
                    }
                }, 3500);
            }

            setTimeout(function () {
                fadeOutLogoOverlay.classList.add('opacity-0');
            }, 4000);

            for (const navLogo of navLogos) {
                navLogo.classList.add('opacity-0');
                setTimeout(function () {
                    navLogo.classList.add('transition-all','duration-1000','ease-in-out');
                }, 2550);

                setTimeout(function () {
                    navLogo.classList.remove('opacity-0');
                }, 3750);
            }

        }

        const textSpans = headerPanel.querySelectorAll("[data-dynamic-typed-text]");

        for (const textSpan of textSpans) {
            const messages = JSON.parse(textSpan.dataset.rotatingMessages);

            let currentIndex = 0;
            let nextIndex = (currentIndex + 1) % messages.length;
            let currentMessage = messages[currentIndex];
            let nextMessage = messages[nextIndex];
            let commonPrefixLength = 0;
            let charIndex = 0;

            let typing = false;
            let deleting = false;

            const typingSpeed = 100;
            const erasingSpeed = 50;
            const delayBetweenMessages = 7500;

            // Ensure we always track what's actually being typed
            let displayText = currentMessage;
            textSpan.textContent = displayText;

            function getCommonPrefixLength(a, b) {
                let i = 0;
                while (i < a.length && i < b.length && a[i] === b[i]) {
                    i++;
                }
                return i;
            }

            function animate() {
                if (!deleting && !typing) {
                    // Prepare next message
                    nextMessage = messages[nextIndex];
                    commonPrefixLength = getCommonPrefixLength(currentMessage, nextMessage);
                    charIndex = displayText.length; // start deleting from full current display
                    deleting = true;
                    setTimeout(animate, erasingSpeed);
                    return;
                }

                if (deleting) {
                    if (charIndex > commonPrefixLength) {
                        charIndex--;
                        displayText = displayText.slice(0, charIndex);
                        textSpan.textContent = displayText;
                        setTimeout(animate, erasingSpeed);
                    } else {
                        deleting = false;
                        typing = true;
                        charIndex = commonPrefixLength;
                        displayText = nextMessage.slice(0, charIndex);
                        textSpan.textContent = displayText;
                        setTimeout(animate, typingSpeed);
                    }
                    return;
                }

                if (typing) {
                    if (charIndex < nextMessage.length) {
                        displayText += nextMessage.charAt(charIndex);
                        textSpan.textContent = displayText;
                        charIndex++;
                        setTimeout(animate, typingSpeed);
                    } else {
                        typing = false;
                        currentIndex = nextIndex;
                        nextIndex = (currentIndex + 1) % messages.length;
                        currentMessage = messages[currentIndex];
                        setTimeout(animate, delayBetweenMessages);
                    }
                    return;
                }
            }

            if (navLogos.length && fadeOutLogoOverlay ) {
                // wait for animation sequence to finish
                setTimeout(function () {
                    animate();
                }, 10000);
            } else {
                animate();
            }
        }
    }

});